module.exports = __webpack_public_path__ + "img/Step2.7b233da.svg";